define('lq/events/actions/asyncDeletion',[
    'lq/events/actions/eventAction'
], function(EventAction) {
    'use strict';
        
    function AsyncDeletion(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(AsyncDeletion, EventAction);

    AsyncDeletion.typeName = 'AsyncDeletion';

    AsyncDeletion.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };
        
    AsyncDeletion.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'AsyncDeletion',
            command: this.eventData.command
        };
    };

    return AsyncDeletion;
});
